<app-base-edit-form-modal [baseService]="addressService">
  <app-address-details [closeOnSave]="false" (saved)="saved($event)"></app-address-details>
</app-base-edit-form-modal>
